import { render, staticRenderFns } from "./Agile.vue?vue&type=template&id=60be9220&"
import script from "./Agile.vue?vue&type=script&lang=js&"
export * from "./Agile.vue?vue&type=script&lang=js&"
import style0 from "./Agile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60be9220')) {
      api.createRecord('60be9220', component.options)
    } else {
      api.reload('60be9220', component.options)
    }
    module.hot.accept("./Agile.vue?vue&type=template&id=60be9220&", function () {
      api.rerender('60be9220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-agile/src/Agile.vue"
export default component.exports